<template>
  <v-dialog max-width="400" v-model="show" persistent>
    <v-card>
      <v-card-title>
        <div class="md-subheader-no-spacing">
          Consolidate Tax and Fee
        </div></v-card-title
      >
      <v-card-text>
        <div class="md-body-no-spacing">
          To use the shopper allowance or coupons, deselect "Consolidate Tax and
          Fee". The "Consolidate Tax and Fee" feature is unavailable if shopper
          allowance or coupons are selected.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="show = false">
          Okay
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/rules";

export default {
  props: {},

  mixins: [rules],

  watch: {},

  data() {
    return {
      show: false,
    };
  },

  async mounted() {},

  methods: {
    open() {
      this.show = true;
    },
  },
};
</script>

<style scoped>
</style>
